import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const tealBorder = "#06d1c6";
const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  border: `1px solid ${tealBorder}`,
  borderRadius: "6px",
  backgroundColor: "#fff",
  color: "#334155",
  fontSize: "14px",
};

const tableHeaderStyle = {
  backgroundColor: "#f1f5f9",
  color: "#334155",
  fontWeight: 600,
  fontSize: "13px",
  padding: "10px 12px",
};

const UCC_COLUMNS = [
  "Select",
  "ARN",
  "UCC",
  "First Holders",
  "Tax Status",
  "Holding",
  "Joint holders",
  "Nominee",
];

export default function TransferHolding() {
  const [selectUser, setSelectUser] = useState("");
  const [transactionType, setTransactionType] = useState("switch"); // "switch" | "redemption"
  const [selectFund, setSelectFund] = useState("");
  const [folio, setFolio] = useState("");
  const [schemeFrom, setSchemeFrom] = useState("");
  const [schemeTo, setSchemeTo] = useState("");
  const [chooseArn, setChooseArn] = useState("");

  const handleSwitchAllUnits = (e) => {
    e.preventDefault();
    // TODO: API - transfer holding / switch
    console.log({
      selectUser,
      transactionType,
      selectFund,
      folio,
      schemeFrom,
      schemeTo,
      chooseArn,
    });
  };

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header */}
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Transfer Holding</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/admin/invest-bse/profile-list">Invest Online BSE</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Transfer Holding
                </li>
              </ol>
            </nav>
          </div>

          {/* Page title */}
          <h1 style={{ fontSize: "22px", fontWeight: 700, color: "#334155", marginBottom: "12px" }}>
            Transfer Holding
          </h1>
          <p style={{ color: "#64748b", fontSize: "14px", marginBottom: "24px", lineHeight: 1.6 }}>
            Admin may use this screen to input a switch transaction here. No check is made on Schemes or Folios or Balance Units. Please enter details carefully. Investor will get a message from the Exchange for confirmation, as usual.
          </p>

          {/* Main form card */}
          <div style={cardStyle}>
            <form onSubmit={handleSwitchAllUnits}>
              <div className="mb-3">
                <label className="form-label small fw-semibold text-secondary mb-1 d-block">Select User:</label>
                <input
                  type="text"
                  placeholder="Type to Search..."
                  value={selectUser}
                  onChange={(e) => setSelectUser(e.target.value)}
                  style={{ ...inputStyle, maxWidth: 400 }}
                />
              </div>

              <div className="mb-3">
                <div className="form-label small fw-semibold text-secondary mb-2 d-block">Transaction Type</div>
                <div className="d-flex gap-4">
                  <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                    <input
                      type="radio"
                      name="transactionType"
                      checked={transactionType === "switch"}
                      onChange={() => setTransactionType("switch")}
                      style={{ accentColor: "#10b981" }}
                    />
                    Switch
                  </label>
                  <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                    <input
                      type="radio"
                      name="transactionType"
                      checked={transactionType === "redemption"}
                      onChange={() => setTransactionType("redemption")}
                      style={{ accentColor: "#10b981" }}
                    />
                    Redemption
                  </label>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label small fw-semibold text-secondary mb-2 d-block">Select UCC:</label>
                <div style={{ overflowX: "auto" }}>
                  <table className="table table-bordered mb-0" style={{ fontSize: "13px" }}>
                    <thead>
                      <tr>
                        {UCC_COLUMNS.map((col) => (
                          <th key={col} style={tableHeaderStyle}>
                            {col === "Select" ? (
                              <input type="checkbox" aria-label="Select all" />
                            ) : (
                              col
                            )}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan={UCC_COLUMNS.length} style={{ textAlign: "center", padding: "24px", color: "#ea580c", fontSize: "14px" }}>
                          <span className="me-2" aria-hidden>⚠</span>
                          No data available.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row g-3 mb-3">
                <div className="col-12 col-md-6">
                  <label className="form-label small fw-semibold text-secondary mb-1 d-block">Select Fund :</label>
                  <select
                    value={selectFund}
                    onChange={(e) => setSelectFund(e.target.value)}
                    style={inputStyle}
                  >
                    <option value="">Select</option>
                    <option value="equity">Equity</option>
                    <option value="debt">Debt</option>
                    <option value="hybrid">Hybrid</option>
                  </select>
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label small fw-semibold text-secondary mb-1 d-block">Folio :</label>
                  <input
                    type="text"
                    value={folio}
                    onChange={(e) => setFolio(e.target.value)}
                    style={inputStyle}
                    placeholder=""
                  />
                </div>
              </div>

              <div className="row g-3 mb-3">
                <div className="col-12 col-md-6">
                  <label className="form-label small fw-semibold text-secondary mb-1 d-block">Scheme From:</label>
                  <input
                    type="text"
                    placeholder="Type to Search..."
                    value={schemeFrom}
                    onChange={(e) => setSchemeFrom(e.target.value)}
                    style={inputStyle}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label small fw-semibold text-secondary mb-1 d-block">Scheme To:</label>
                  <input
                    type="text"
                    placeholder="Type to Search..."
                    value={schemeTo}
                    onChange={(e) => setSchemeTo(e.target.value)}
                    style={inputStyle}
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label small fw-semibold text-secondary mb-1 d-block">Choose ARN :</label>
                <select
                  value={chooseArn}
                  onChange={(e) => setChooseArn(e.target.value)}
                  style={{ ...inputStyle, maxWidth: 300 }}
                >
                  <option value="">Select</option>
                  <option value="arn-315999">ARN-315999</option>
                  <option value="arn-316000">ARN-316000</option>
                </select>
              </div>

              <div>
                <button
                  type="submit"
                  style={{
                    background: tealBorder,
                    color: "#fff",
                    border: "none",
                    padding: "10px 24px",
                    borderRadius: "8px",
                    fontWeight: 600,
                    fontSize: "15px",
                    cursor: "pointer",
                  }}
                >
                  Switch All Units
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
